/**
 * Collection Variant Sort
 *
 * This module sort variants in order on collection landing page.
 * Dependancy with variants array in sections/collection.liquid.
 */
require('custom/algolia-utils');
require('custom/utils'); // getDeviceSizeName

custom.variantSort = (() => {
  const initId = 'js-collection-variants';

  /**
   * decodeHTMLEntities
   * @param {array} arr - Array of variant text with encoded
   * Returns array after decoding all HTML entities
   */
  function decodeHTMLEntities(arr = []) {
    const parser = new DOMParser();
    return arr.map(
      (val) => parser.parseFromString(val, 'text/html').body.textContent,
    );
  }

  /**
   * sortHandler
   * @param {array} arr - Array of variant text
   * Returns in-order variant array based on
   * custom.algoliaUtils.getSizeNum calculation
   */
  function sortHandler(arr = []) {
    return arr.sort((a, b) => {
      return (
        custom.algoliaUtils.getSizeNum(a) - custom.algoliaUtils.getSizeNum(b)
      );
    });
  }

  function render(variants = []) {
    variants = variants.filter((variant) => variant !== 'Default Title');
    const variantContainer = document.getElementById(initId);
    let output = '';

    variants.forEach((variant, index) => {
      if (index !== 0) {
        output += `<span class="variant-separator text-grey-4 inline-block mx-3">|</span>`;
      }
      output += `<p class="inline-block">${variant}</p>`;
    });
    variantContainer.innerHTML = output;
  }

  function init(variants = []) {
    if (!variants) return false;
    variants = sortHandler(decodeHTMLEntities(variants));
    render(variants);
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/variant-sort.js